const e=(e,t,n,o=!1)=>!(!e||"function"!=typeof e.addEventListener)&&(e.addEventListener(t,n,o),!0),t=(e,t,n,o=!1)=>!(!e||"function"!=typeof e.removeEventListener)&&(e.removeEventListener(t,n,o),!0);export{t as off,e as on};
//# sourceMappingURL=listenerUtils.js.map
